import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeEmailSignIn } from '../config/firebase';

export default function EmailCallback() {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function finishSignIn() {
      try {
        const result = await completeEmailSignIn();
        if (result) {
          navigate('/', { replace: true });
        } else {
          setError('Unable to complete sign-in. Please try again.');
        }
      } catch (err) {
        setError(err.message);
      }
    }
    finishSignIn();
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 50%, #2ec4b6 100%)'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        padding: '48px 40px',
        maxWidth: '420px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
      }}>
        {error ? (
          <>
            <div style={{ fontSize: '18px', fontWeight: 600, color: '#e07a5f', marginBottom: '12px' }}>
              Sign-in Error
            </div>
            <div style={{ fontSize: '14px', color: '#5a6577', marginBottom: '24px' }}>{error}</div>
            <button
              onClick={() => navigate('/login', { replace: true })}
              style={{
                padding: '12px 24px',
                borderRadius: '10px',
                border: 'none',
                background: '#0f4c5c',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              Back to Login
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: '18px', fontWeight: 600, color: '#1a2332', marginBottom: '8px' }}>
              Completing sign-in...
            </div>
            <div style={{ fontSize: '14px', color: '#8a94a3' }}>Please wait</div>
          </>
        )}
      </div>
    </div>
  );
}
